module.exports = __webpack_public_path__ + "img/Manual Exam Upload - Blue - Selected.2fe90f8b.png";